// The decision log is an EE feature, so there is no client-only field to serve here. The EE file of
// the same name overrides this through the `ee_else_ce` alias.
export const decisionLogStubResolvers = { Query: {}, Mutation: {} };
